import { render, staticRenderFns } from "./ProjectConfigurationComponent.vue?vue&type=template&id=5927d480&scoped=true"
import script from "./ProjectConfigurationComponent.vue?vue&type=script&lang=js"
export * from "./ProjectConfigurationComponent.vue?vue&type=script&lang=js"
import style0 from "./ProjectConfigurationComponent.vue?vue&type=style&index=0&id=5927d480&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5927d480",
  null
  
)

export default component.exports